import React from "react";
import { LocalizationContext } from "localization-context";
import { AlexaCommon } from "../utils/Common";
const autoBind = require("auto-bind");

class RZAccountPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: localStorage.getItem("firstName")
    };
    this.avsWrapper = props.avsWrapper;
    autoBind(this);
  }

  handleSignOutClick() {
    this.avsWrapper.doLogout();
  }
  handleFAQClick =()=>{
    
    window.rzevent.triggerEvent(window.rzevent.EventTypes.OPEN_URL, "https://support.razer.com/articles/1541045551");
    //window.open("https://support.razer.com/articles/1541045551");
  }
  componentDidMount() {
    AlexaCommon.getAmazonUserName()
      .then(res => {
        this.setState({
          username: res.name.split(" ")[0]
        });
        localStorage.setItem("firstName", this.state.username);
      })
      .catch(err =>{
        console.log("getAmazonUserName error: Amazon token invalid/expired." + JSON.stringify(err));
      });
  }

  render() {
    return (
      <LocalizationContext.Consumer>
        {values => (
          <div className="settings-container-1" style={{ paddingTop: "10px" }}>
            <div className="settings-wrapper-1">
              <div className="settings-title alexa-none">
                <span>{values.account}</span>
              </div>
              <div className="settings-account">
                <div className="settings-subtitle settings-subcontent" style={{width:'500px'}}>
                  <span>{values.notUserFront}</span> <span>{this.state.username}</span> <span>{values.notUserBack}</span>{" "}
                  <span
                    style={{ marginLeft: 10 + "px", marginRight:'220px' }}
                    className="alexa-underline-special-btn"
                    onClick={this.handleSignOutClick}
                  >
                    {values.signOut}
                  </span>
                  <span
                    style={{ textAlign:'right', float:'right' }}
                    className="alexa-underline-special-btn"
                    onClick={this.handleFAQClick}
                  >
                    {values.AlexaGuide}
                  </span>
                 
                </div>
               
               
              </div>
            </div>
           
          </div>
        )}
      </LocalizationContext.Consumer>
    );
  }
}

export default RZAccountPanel;
